import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import authorizationService from '../../../services/security/authorizationService';
import {
  setLoggedInUserSucceeded,
  setUserRole,
  setActualUserRole,
} from './loggedInUserSlice';
import loggedInUserMapper from '../../../services/security/loggedInUserMapper';

export const setLoggedInUserThunk = (path) => async (dispatch) => {
  const jwtToken = authorizationService.getToken();
  const setLoggedInUser = loggedInUserMapper.map(jwtToken);
  dispatch(setLoggedInUserSucceeded(setLoggedInUser));
  // The below logic is used when navigating from any screen back to project lisiting page.
  // A user will be decided as a TP or not once he opens a project and when the user is on the
  // the lisiting screen the user is either pwc or client user based on jwtToken - isInternal claim.
  if (path === '/projects') {
    if (jwtToken.isInternal === 'True') {
      dispatch(setUserRole(USER_ROLES.PWC_USER));
      dispatch(setActualUserRole(USER_ROLES.PWC_USER));
    } else {
      dispatch(setUserRole(USER_ROLES.CLIENT));
      dispatch(setActualUserRole(USER_ROLES.CLIENT));
    }
  }
};
